import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WidgetBody } from './WidgetBody.js';
const KIND_LABEL = {
    kpi: 'key figure',
    chart: 'chart',
    table: 'table',
    text: 'note'
};
/**
 * The frame every widget sits in, identical in the viewer and the editor.
 *
 * No card chrome (spec §6.3) — no border, radius or shadow. A title sits
 * under a 1px ink rule; the widget's own body fills the rest.
 *
 * A KPI carries its own title inside the body (title above the number is what
 * makes a KPI figure readable), so the frame does not repeat it — a
 * duplicated heading would be read twice by a screen reader.
 *
 * The title is an `<h2>`, and every widget kind agrees on that level — see
 * `WidgetBody`'s KPI label and `PrintReport`'s block titles. A report has
 * exactly two structural layers: the report itself (`<h1>`, ReportHeader) and
 * the widgets in it. There is no third layer, so numbering these `<h3>`
 * asserted a section grouping that does not exist, and left every report
 * jumping h1 → h3 — axe's `heading-order`, and a screen-reader user
 * navigating by heading meeting a level-3 item with nothing above it. The
 * level must stay uniform across kinds: making only one kind an `<h2>` moves
 * the break rather than closing it, since whichever kind still emits `<h3>`
 * produces the same jump as soon as it is the first widget in the layout.
 */
export function WidgetFrame({ view, animate }) {
    return (_jsxs("section", { className: "tf-widget", "aria-label": `${view.widget.title} — ${KIND_LABEL[view.kind]}`, children: [view.kind === 'kpi' ? null : (_jsx("header", { className: "tf-widget-header", children: _jsx("h2", { className: "tf-widget-title", title: view.widget.title, children: view.widget.title }) })), _jsx("div", { className: "tf-widget-body", children: _jsx(WidgetBody, { view: view, animate: animate, paginate: true }) })] }));
}
//# sourceMappingURL=WidgetFrame.js.map